// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://static.rambler.ru/fonts/CorsicaRamblerLX/CorsicaRamblerLX.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}
div.src-components-Topline-styles--desktop--an12x {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  background-color: #fff;
  background-color: var(--mainBackground);
}
div.src-components-Topline-styles--desktop--an12x * {
    box-sizing: border-box;
  }
div.src-components-Topline-styles--mobile--XgmsV {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  display: block;
}
div.src-components-Topline-styles--mobile--XgmsV a {
    border-bottom: inherit;
  }
div.src-components-Topline-styles--mobile--XgmsV .rambler-topline-projects-dropdown__item {
    overflow: hidden;
  }
div.src-components-Topline-styles--mobile--XgmsV * {
    box-sizing: border-box;
  }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/Topline/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;ACnBA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sBAAuC;EAAvC,uCAAuC;AAKzC;AAHE;IACE,sBAAsB;EACxB;AAGF;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,cAAc;AAahB;AAXE;IACE,sBAAsB;EACxB;AAEA;IACE,gBAAgB;EAClB;AAEA;IACE,sBAAsB;EACxB","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import url('https://static.rambler.ru/fonts/CorsicaRamblerLX/CorsicaRamblerLX.css');\n@import 'utils/variables.css';\n\ndiv.desktop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  background-color: var(--mainBackground);\n\n  & * {\n    box-sizing: border-box;\n  }\n}\n\ndiv.mobile {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  display: block;\n\n  & a {\n    border-bottom: inherit;\n  }\n\n  & :global(.rambler-topline-projects-dropdown__item) {\n    overflow: hidden;\n  }\n\n  & * {\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"desktop": `src-components-Topline-styles--desktop--an12x`,
	"mobile": `src-components-Topline-styles--mobile--XgmsV`
};
module.exports = ___CSS_LOADER_EXPORT___;
